// Leaf grouping helpers for the main compiler entry pipeline.
// Example: one pass builds regular CSS leaves plus observed runtime payloads.
import { renderLeafRule } from './renderer'
import type { LuisRenderLeaf } from './renderer'
import type { PartitionedRenderLeaves } from './index-types'

// Check how many leaves produce observed runtime rules.
export function countObservedLeaves(leaves: LuisRenderLeaf[]): number {
  let observedLeafCount = 0
  // Check each leaf and count only observed runtime variants.
  for (const leaf of leaves) {
    if (leaf.observedMode !== 'none') observedLeafCount += 1
  }
  // Return the total observed leaf count.
  return observedLeafCount
}

// Build grouped render-leaf outputs for CSS and runtime payload generation.
export function partitionRenderLeaves(leaves: LuisRenderLeaf[]): PartitionedRenderLeaves {
  const regularLeaves: LuisRenderLeaf[] = []
  const mainRules: PartitionedRenderLeaves['mainRules'] = []
  const observedRules: PartitionedRenderLeaves['observedRules'] = []
  const initialObservedRules: PartitionedRenderLeaves['initialObservedRules'] = []
  // Start one source-ordered leaf grouping pass.
  for (const leaf of leaves) {
    const rule = renderLeafRule(leaf)
    const baseRule = { key: leaf.key, selector: leaf.selector, atRules: [...leaf.atRules], line: leaf.sourceLine, rule }
    if (leaf.observedMode === 'none') {
      regularLeaves.push(leaf)
      mainRules.push({ ...baseRule, observedMode: 'none' })
    } else if (leaf.observedMode === 'dynamic') {
      observedRules.push(baseRule)
    } else if (leaf.observedMode === 'initial') {
      regularLeaves.push(leaf)
      mainRules.push({ ...baseRule, observedMode: 'initial' })
      initialObservedRules.push(baseRule)
    }
  }
  // Return grouped leaf outputs for CSS and observed runtime payloads.
  return { regularLeaves, mainRules, observedRules, initialObservedRules }
}
